import {
  AUTHENTICATED,
  HIDE_AUTH_MESSAGE,
  SHOW_AUTH_MESSAGE,
  SHOW_AUTH_SUCCESS_MESSAGE,
  SHOW_LOADING,
  SIGNIN,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SIGNUP,
  SIGNUP_SUCCESS,
  REDIRECT_TO_VERIFY_EMAIL,
  REDIRECT_TO_CONFIGURE_MFA,
  SHOW_MFA_VERIFICATION,
  HIDE_MFA_VERIFICATION,
  VERIFY_MFA_CODE,
  MFA_VERIFICATION_SUCCESS
} from "../constants/Auth";

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user,
  };
};

export const authenticated = (user) => {
  return {
    type: AUTHENTICATED,
    user,
  };
};

export const signOut = () => {
  return {
    type: SIGNOUT,
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  };
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user,
  };
};

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token,
  };
};

export const signInWithGoogle = () => {
  return {
    type: SIGNIN_WITH_GOOGLE,
  };
};

export const signInWithGoogleAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    token,
  };
};

export const signInWithFacebook = () => {
  return {
    type: SIGNIN_WITH_FACEBOOK,
  };
};

export const signInWithFacebookAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    token,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
  };
};

export const showAuthSuccessMessage = (message) => {
  return {
    type: SHOW_AUTH_SUCCESS_MESSAGE,
    message,
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const redirectToVerifyEmail = () => {
  return {
    type: REDIRECT_TO_VERIFY_EMAIL,
  };
};
export const redirectToConfigureMFA = () => {
  return {
    type: REDIRECT_TO_CONFIGURE_MFA,
  };
};

export const showMfaVerification = (resolver, email) => {
  return {
    type: SHOW_MFA_VERIFICATION,
    payload: { resolver, email },
  };
};

export const hideMfaVerification = () => {
  return {
    type: HIDE_MFA_VERIFICATION,
  };
};

export const verifyMfaCode = (code, resolver) => {
  return {
    type: VERIFY_MFA_CODE,
    payload: { code, resolver },
  };
};

export const mfaVerificationSuccess = (token) => {
  return {
    type: MFA_VERIFICATION_SUCCESS,
    token,
  };
};
